import { FormControl, UntypedFormGroup, Validator, ValidatorFn, Validators } from '@angular/forms';

export const FormSwitchValidatorHelper = (form: UntypedFormGroup, controls: string[], validator?: ValidatorFn[]) => {
  controls.forEach(control => {
    form.controls[control].setValidators(validator);
    form.controls[control].updateValueAndValidity();
  });
};
